import { Route, Switch } from 'react-router-dom';
import { routes } from 'Constants/routes';
import QuizInitial from '../QuizInitial';
import Quiz from '../Quiz';
import QuizResult from '../QuizResult';

const ROUTES = [
  {
    route: routes.DATAGATHERING_QUIZ,
    Component: QuizInitial,
  },
  {
    route: routes.DATAGATHERING_QUIZ_RESULT,
    Component: QuizResult,
  },
];

const QuizRouteHandler = (): JSX.Element => {
  return (
    <Switch>
      {ROUTES.map(({ route, Component }) => (
        <Route key={route} exact path={route} render={props => <Component {...props} />} />
      ))}
      <Route
        exact
        path={`${routes.DATAGATHERING_QUIZ}/question/:questionNumber`}
        render={props => <Quiz {...props} />}
      />
    </Switch>
  );
};

export default QuizRouteHandler;
